(function () {
  'use strict';

  var routes = { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js', cart: '/cart.js' };

  /* ---------- helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  /* ---------- mobile menu ---------- */
  var mobileMenu = qs('[data-mobile-menu]');
  qsa('[data-mobile-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { mobileMenu && mobileMenu.classList.add('is-open'); });
  });
  qsa('[data-mobile-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { mobileMenu && mobileMenu.classList.remove('is-open'); });
  });

  /* ---------- predictive search panel ---------- */
  var searchPanel = qs('[data-search-panel]');
  qsa('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchPanel) return;
      searchPanel.classList.toggle('is-open');
      if (searchPanel.classList.contains('is-open')) { var i = qs('input', searchPanel); i && i.focus(); }
    });
  });
  qsa('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { searchPanel && searchPanel.classList.remove('is-open'); });
  });

  /* ---------- cart drawer ---------- */
  var cartDrawer = qs('#CartDrawer');

  function openCartDrawer() { cartDrawer && cartDrawer.classList.add('is-open'); }
  function closeCartDrawer() { cartDrawer && cartDrawer.classList.remove('is-open'); }

  qsa('[data-cart-open]').forEach(function (btn) { btn.addEventListener('click', openCartDrawer); });
  qsa('[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = el.hasAttribute('data-cart-count-paren') ? '(' + count + ')' : count; });
  }

  function updateFreeShippingBar(cart) {
    var bar = qs('[data-cart-shipping-bar]');
    if (!bar) return;
    var threshold = parseFloat(bar.dataset.threshold || document.body.dataset.freeShippingThreshold || 50) * 100;
    threshold = threshold || 5000;
    var fill = qs('[data-cart-shipping-fill]', bar);
    var text = qs('[data-cart-shipping-text]', bar);
    var remaining = threshold - cart.total_price;
    var pct = Math.min(100, (cart.total_price / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (remaining <= 0) {
        text.textContent = "You've unlocked free shipping!";
      } else {
        text.textContent = (remaining / 100).toFixed(2) + ' away from free shipping';
      }
    }
  }

  function refreshCartDrawer() {
    fetchJSON(routes.cart).then(function (cart) {
      updateCartCount(cart.item_count);
      updateFreeShippingBar(cart);
      var subtotal = qs('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      renderCartItems(cart);
    });
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active + ' ' : '€') + value;
  }

  function renderCartItems(cart) {
    var wrap = qs('[data-cart-items]');
    if (!wrap) return;
    if (cart.item_count === 0) {
      wrap.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p></div>';
      return;
    }
    var html = '<ul class="cart-drawer__list">';
    cart.items.forEach(function (item) {
      html += '<li class="cart-drawer__item" data-cart-item data-key="' + item.key + '" data-line-id="' + item.id + '">' +
        '<a href="' + item.url + '" class="cart-drawer__item-image"><img src="' + item.image + '" width="80" height="80" alt=""></a>' +
        '<div class="cart-drawer__item-info"><a href="' + item.url + '">' + item.product_title + '</a>' +
        (item.variant_title ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '') +
        '<div class="cart-drawer__item-qty"><button type="button" data-cart-qty-minus>−</button><span data-cart-qty>' + item.quantity + '</span><button type="button" data-cart-qty-plus>+</button></div>' +
        '</div><div class="cart-drawer__item-price"><span>' + formatMoney(item.final_line_price) + '</span>' +
        '<button type="button" class="cart-drawer__item-remove" data-cart-remove>Remove</button></div></li>';
    });
    html += '</ul>';
    wrap.innerHTML = html;
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('[data-cart-qty-minus]');
    var plus = e.target.closest && e.target.closest('[data-cart-qty-plus]');
    var remove = e.target.closest && e.target.closest('[data-cart-remove]');
    if (!minus && !plus && !remove) return;
    var li = e.target.closest('[data-cart-item]');
    if (!li) return;
    var key = li.dataset.key;
    var qtyEl = qs('[data-cart-qty]', li);
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var newQty = qty;
    if (minus) newQty = Math.max(0, qty - 1);
    if (plus) newQty = qty + 1;
    if (remove) newQty = 0;
    fetchJSON(routes.cartChange, { method: 'POST', body: JSON.stringify({ id: key, quantity: newQty }) })
      .then(refreshCartDrawer);
  });

  /* ---------- quick add (cart drawer upsell) ---------- */
  qsa('[data-cart-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-cart-quick-add');
      fetchJSON(routes.cartAdd, { method: 'POST', body: JSON.stringify({ id: id, quantity: 1 }) })
        .then(function () { refreshCartDrawer(); openCartDrawer(); });
    });
  });

  /* ---------- announcement bar countdown ---------- */
  qsa('[data-countdown]').forEach(function (el) {
    var hours = parseInt(el.dataset.hours, 10) || 24;
    var key = 'bh_countdown_end';
    var end = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!end || end < now) {
      end = now + hours * 60 * 60 * 1000;
      localStorage.setItem(key, end);
    }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = ' · ends in ' + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      if (diff <= 0) { localStorage.removeItem(key); }
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- before / after slider ---------- */
  qsa('[data-before-after]').forEach(function (wrap) {
    var before = qs('[data-before-clip]', wrap);
    var handle = qs('[data-before-handle]', wrap);
    var dragging = false;

    function setPosition(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      before.style.width = pct + '%';
      handle.style.left = pct + '%';
    }
    wrap.addEventListener('pointerdown', function (e) { dragging = true; setPosition(e.clientX); });
    window.addEventListener('pointermove', function (e) { if (dragging) setPosition(e.clientX); });
    window.addEventListener('pointerup', function () { dragging = false; });
  });

  /* ---------- product gallery ---------- */
  qsa('[data-gallery]').forEach(function (gallery) {
    var mainImg = qs('[data-gallery-main-image]', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-full');
        qsa('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- product form: quantity, bundle/variant selection, add to cart ---------- */
  qsa('[data-product-form]').forEach(function (form) {
    var qtyInput = qs('[data-qty-input]', form);
    var variantIdInput = qs('[data-variant-id]', form);
    var addBtn = qs('[data-add-to-cart]', form);
    var addLabel = qs('[data-add-to-cart-label]', addBtn || form);

    qs('[data-qty-minus]', form) && qs('[data-qty-minus]', form).addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
    qs('[data-qty-plus]', form) && qs('[data-qty-plus]', form).addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });

    function getProductData() {
      var section = form.closest('[data-product-handle]');
      return section && window.__productJSON ? window.__productJSON[section.dataset.productHandle] : null;
    }

    function updatePriceDisplay(variantId) {
      var product = getProductData();
      if (!product) return;
      var variant = product.variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
      if (!variant) return;
      var priceEl = qs('[data-price]');
      var comparePriceEl = qs('[data-compare-price]');
      var stickyPrice = qs('[data-sticky-price]');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.style.display = '';
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (addBtn) addBtn.toggleAttribute('disabled', !variant.available);
    }

    qsa('[data-bundle-radio]', form).forEach(function (radio) {
      radio.addEventListener('change', function () {
        variantIdInput.value = radio.value;
        qsa('.bundle-card', form).forEach(function (card) { card.classList.remove('is-selected'); });
        radio.closest('.bundle-card') && radio.closest('.bundle-card').classList.add('is-selected');
        updatePriceDisplay(radio.value);
      });
    });

    var optionSelects = qsa('[data-option-select]', form);
    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var product = getProductData();
        if (!product) return;
        var chosen = optionSelects.map(function (s) { return s.value; });
        var match = product.variants.filter(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        })[0];
        if (match) {
          variantIdInput.value = match.id;
          updatePriceDisplay(match.id);
        }
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn) addBtn.setAttribute('disabled', 'disabled');
      if (addLabel) addLabel.textContent = 'Adding…';
      var formData = new FormData(form);
      fetchJSON(routes.cartAdd, { method: 'POST', body: formData })
        .then(function (res) {
          if (addLabel) addLabel.textContent = 'Added ✓';
          refreshCartDrawer();
          openCartDrawer();
          setTimeout(function () {
            if (addLabel) addLabel.textContent = 'Add to cart';
            if (addBtn) addBtn.removeAttribute('disabled');
          }, 1800);
        })
        .catch(function () {
          if (addLabel) addLabel.textContent = 'Add to cart';
          if (addBtn) addBtn.removeAttribute('disabled');
        });
    });
  });

  /* ---------- sticky add to cart bar ---------- */
  var stickyBar = qs('[data-sticky-atc]');
  var buybox = qs('[data-buybox]');
  if (stickyBar && buybox) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(buybox);
    qs('[data-sticky-add-to-cart]', stickyBar) && qs('[data-sticky-add-to-cart]', stickyBar).addEventListener('click', function () {
      var mainForm = qs('[data-product-form]');
      if (mainForm) mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ---------- initial state ---------- */
  if (qs('[data-cart-shipping-bar]')) {
    fetchJSON(routes.cart).then(function (cart) { updateFreeShippingBar(cart); });
  }

  /* ---------- newsletter form success (no-JS fallback already handled server-side) ---------- */
})();
